import React, { Component } from "react";
import { Messages } from "primereact/messages";
import { Growl } from "primereact/growl";
import axios from "axios";
import { AutoComplete } from "primereact/autocomplete";
import "react-datepicker/dist/react-datepicker.css";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import "react-datepicker/dist/react-datepicker.css";
import * as appConst from "../../Common/constants";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";

export default class Return extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spinnerClass: "collapse",
      dataClass: "",
      nameSuggestions: null,
      nameList: [],
      medList: [],
      mainStock: 0,
      subStock: 0,
      qty: 0,
      mno: "",
      name: "",
      source: "",
      purchase: [],
      purchaseClass: "collapse"
    };
  }

  componentDidMount() {
    this.LoadNames();
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/medicine/getNames"
      )
      .then(response => {
        this.setState({ medList: response.data });
        let nameData = response.data;
        nameData.forEach(function(item) {
          _nameList.push(item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  render() {
    return (
      <div>
        <div>
          <h5 align="center">Medicine Return</h5>
        </div>
        <div className="container-fluid">
          <div className="row p-1 border">
            <div className="col col-md-2">Medicine</div>
            <div className="col col-md-4">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={38}
                className="p-error"
              />
            </div>
          </div>

          <div className={this.state.purchaseClass}>
            <div
              className="col col-md-12 ag-theme-blue"
              style={this.getHeight()}
            >
              <AgGridReact
                rowData={this.state.purchase}
                pagination={true}
                enableSorting={true}
                enableFilter={true}
                onGridReady={this.onGridReady}
                paginationAutoPageSize={true}
              >
                <AgGridColumn field="_id" hide="true" />
                <AgGridColumn
                  field="expdate"
                  headerName="Expiry Date"
                  width={130}
                  sortable
                  resizable
                  filter
                  valueFormatter={this.dateFormatter}
                />
                <AgGridColumn
                  field="mainStock"
                  headerName="Main Stock"
                  width={130}
                  sortable
                  resizable
                  filter
                />

                <AgGridColumn
                  field="mainRet"
                  headerName="Main Stock Return"
                  width={200}
                  sortable
                  resizable
                  filter
                  editable
                  onCellValueChanged={this.mainValueChanged}
                />
                <AgGridColumn
                  field="subStock"
                  headerName="Sub Stock"
                  width={130}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="subRet"
                  headerName="Sub Stock Return"
                  width={200}
                  sortable
                  resizable
                  filter
                  editable
                  onCellValueChanged={this.subValueChanged}
                />

                <AgGridColumn
                  width={130}
                  headerName="Return"
                  cellRendererFramework={this.renderButton}
                />
              </AgGridReact>
            </div>
          </div>
          <Growl ref={el => (this.growl = el)} />
          <Messages ref={el => (this.messages = el)} />
        </div>
      </div>
    );
  }

  dateFormatter(params) {
    var arr = params.value.split("-");
    return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
  }

  mainValueChanged = params => {
    this.setState({ [`Main_${params.data._id}`]: params.data.mainRet });
  };

  subValueChanged = params => {
    this.setState({ [`Sub_${params.data._id}`]: params.data.subRet });
  };

  renderButton = params => {
    return (
      <p>
        <a
          onClick={this.onReturnClick}
          className="text-primary"
          data={params.data}
          mainstock={params.data.mainStock}
          substock={params.data.subStock}
          _id={params.data._id}
        >
          Click Here
        </a>
      </p>
    );
  };

  onReturnClick = e => {
    var res = window.confirm("Are you sure to proceed ?");
    if (res == true) {
      var purId = e.target.getAttribute("_id");
      var mainStock = e.target.getAttribute("mainstock");
      var subStock = e.target.getAttribute("substock");

      var mainRet =
        this.state[`Main_${purId}`] === undefined
          ? 0
          : this.state[`Main_${purId}`];
      var subRet =
        this.state[`Sub_${purId}`] === undefined
          ? 0
          : this.state[`Sub_${purId}`];

      if (
        parseInt(mainRet) > parseInt(mainStock) ||
        parseInt(subRet) > parseInt(subStock) ||
        this.state.mno === ""
      ) {
        this.growl.show({
          severity: "error",
          summary: "Error !!",
          detail: "Invalid Input !!"
        });
      } else {
        const obj = {
          mno: this.state.mno,
          name: this.state.name,
          purId: purId,
          mainRet: mainRet,
          subRet: subRet,
          mainStock: mainStock,
          subStock: subStock
        };

        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
               "/medicine/return",
            obj
          )
          .then(res => {
            this.setState({ [`Main_${purId}`]: 0 });
            this.setState({ [`Sub_${purId}`]: 0 });
            this.ClearData();
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Medicine Returned !!!"
            });
            this.LoadNames();
            this.ClearData();
          })
          .catch(error => {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Something went wrong !!"
            });
          });
      }
    }
  };

  onNameSelect = e => {
    this.setState({
      purchaseClass: "collapse",
      purchase: []
    });

    let results = this.state.medList.filter(t => {
      return t.name.toLowerCase() === e.value.toLowerCase();
    })[0];

    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/medicine/getDetails/" +
          results.mno
      )
      .then(response => {
        const purchase = [];
        response.data.purchase
          .filter(x => (x.mainStock > 0 || x.subStock > 0) && x.expdate != null && x.return == 0)
          .map(obj => {
            purchase.push({
              ...obj,
              mainRet: 0,
              subRet: 0
            });
          });

        this.setState({
          purchaseClass: "row p-1 border",
          purchase: purchase
        });
      })
      .catch(function(error) {
        console.log(error);
      });

    this.setState({ mno: results.mno, name: results.name });
  };

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  onNameChange = e => {
    this.setState({
      name: e.value,
      mainStock: 0,
      qty: 0
    });
  };

  ClearData() {
    this.setState({
      name: "",
      qty: 0,
      mainStock: 0,
      subStock: 0,
      mno: "",
      source: "",
      purchase: [],
      purchaseClass: "collapse"
    });
  }
}
